import { getFirestore, collection, doc, getDoc } from "firebase/firestore";
import { app } from "helpers/firebase/auth";

export interface FirebaseConfig {
  privacyPolicy: string;
  termsOfService: string;
  videoTutorialUrl: string;
}

const db = getFirestore(app);

export const getFirebaseConfig = async (): Promise<FirebaseConfig | null> => {
  try {
    const docId = "configData";

    const snapshot = await getDoc(doc(collection(db, "config"), docId));

    if (!snapshot.exists()) return null;

    const data = snapshot.data() as FirebaseConfig;

    return data;
  } catch (error) {
    console.log("Error fetching firebase config", error);
    return null;
  }
};
